let elements = {
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page047_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: { click: 'games/page047_game0/audio/click.mp3' },
  pick: 2,
  progressBar: {
    cssStyle: {
      left: '1282px',
      bottom: '0',
      width: '240px',
      height: '122px',
    },
    image: {
      0: 'games/page013_game0/img/0.png',
      1: 'games/page013_game0/img/1.png',
      2: 'games/page013_game0/img/2.png',
      3: 'games/page013_game0/img/3.png',
    },
  },
  items: [
    {
      id: 'i1',
      audioSrc: 'games/page047_game0/audio/68_jacket.mp3',
      image: {
        pos: {
          // x: 364,
          // y: 421,
          x: 1303,
          y: 647,
        },
        width: 202,
        height: 124,
        src: 'games/page047_game0/img/jacket.png',
      },
      mask: {
        pos: {
          // x: 364,
          // y: 421,
          x: 1303,
          y: 647,
        },
        width: 202,
        height: 124,
        src: 'games/page047_game0/img/jacket_green.png',
      },
    },
    {
      id: 'i2',
      audioSrc: 'games/page047_game0/audio/64_hat.mp3',
      image: {
        pos: {
          x: 1503,
          y: 431,
        },
        width: 263,
        height: 161,
        src: 'games/page047_game0/img/hat.png',
      },
      mask: {
        pos: {
          x: 1503,
          y: 431,
        },
        width: 263,
        height: 161,
        src: 'games/page047_game0/img/hat_green.png',
      },
    },
    {
      id: 'i3',
      linkedId: 'i4',
      audioSrc: 'games/page047_game0/audio/69_shoes.mp3',
      image: {
        pos: {
          x: 1016,
          y: 668,
        },
        width: 49,
        height: 52,
        src: 'games/page047_game0/img/shoes_left.png',
      },
      mask: {
        pos: {
          x: 1016,
          y: 668,
        },
        width: 49,
        height: 52,
        src: 'games/page047_game0/img/shoes_left_green.png',
      },
    },
    {
      id: 'i4',
      linkedId: 'i3',
      audioSrc: 'games/page047_game0/audio/69_shoes.mp3',
      image: {
        pos: {
          x: 1168,
          y: 803,
        },
        width: 56,
        height: 41,
        src: 'games/page047_game0/img/shoes_right.png',
      },
      mask: {
        pos: {
          x: 1168,
          y: 803,
        },
        width: 56,
        height: 41,
        src: 'games/page047_game0/img/shoes_right_green.png',
      },
    },
    {
      id: 'i5',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1634,
          y: 719,
        },
        width: 143,
        height: 111,
        src: 'games/page047_game0/img/jeans_right.png',
      },
      mask: {
        pos: {
          x: 1634,
          y: 719,
        },
        width: 143,
        height: 111,
        src: 'games/page047_game0/img/jeans_right_red.png',
      },
    },
    {
      id: 'i6',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          x: 699,
          y: 467,
        },
        width: 142,
        height: 119,
        src: 'games/page047_game0/img/jeans_left.png',
      },
      mask: {
        pos: {
          x: 699,
          y: 467,
        },
        width: 142,
        height: 119,
        src: 'games/page047_game0/img/jeans_left_red.png',
      },
    },
    {
      id: 'i7',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          // x: 1302,
          // y: 653,
          x: 364,
          y: 430,
        },
        width: 199,
        height: 109,
        src: 'games/page047_game0/img/jumper.png',
      },
      mask: {
        pos: {
          // x: 1302,
          // y: 653,
          x: 364,
          y: 430,
        },
        width: 199,
        height: 109,
        src: 'games/page047_game0/img/jumper_red.png',
      },
    },
    {
      id: 'i8',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          x: 645,
          y: 395,
        },
        width: 145,
        height: 97,
        src: 'games/page047_game0/img/t-shirt_left.png',
      },
      mask: {
        pos: {
          x: 645,
          y: 395,
        },
        width: 145,
        height: 97,
        src: 'games/page047_game0/img/t-shirt_left_red.png',
      },
    },
    {
      id: 'i9',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1587,
          y: 645,
        },
        width: 146,
        height: 92,
        src: 'games/page047_game0/img/t-shirt_right.png',
      },
      mask: {
        pos: {
          x: 1587,
          y: 645,
        },
        width: 146,
        height: 92,
        src: 'games/page047_game0/img/t-shirt_right_red.png',
      },
    },
    {
      id: 'i10',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          x: 172,
          y: 437,
        },
        width: 146,
        height: 127,
        src: 'games/page047_game0/img/dress_left.png',
      },
      mask: {
        pos: {
          x: 172,
          y: 437,
        },
        width: 146,
        height: 127,
        src: 'games/page047_game0/img/dress_left_red.png',
      },
    },
    {
      id: 'i11',
      different: false,
      audioSrc: 'games/page047_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1110,
          y: 648,
        },
        width: 151,
        height: 123,
        src: 'games/page047_game0/img/dress_right.png',
      },
      mask: {
        pos: {
          x: 1110,
          y: 648,
        },
        width: 151,
        height: 123,
        src: 'games/page047_game0/img/dress_right_red.png',
      },
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page047_game0/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 1217,
        y: 263,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game0/audio/65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 1345,
        y: 305,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game0/audio/67_jumper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 1656,
        y: 310,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game0/audio/69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 1059,
        y: 895,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game0/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 833,
        y: 964,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game0/audio/70_jeans.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 644,
        y: 747,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game0/audio/66_dress.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game0/img/audioOn.png', iconOff: 'games/page047_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        x: 236,
        y: 852,
      },
      unit: 'px',
    },
  ],
};

export default elements;
